import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { logout } from '@/lib/auth';
import { useAuthStore } from '@/features/auth/store/auth-store';
import { mapApiError } from '@/lib/error-map';

/** Botón "Cerrar sesión": limpia cookie backend, store local y redirige a /login. */
export function LogoutButton() {
  const navigate = useNavigate();
  const clear = useAuthStore((s) => s.clear);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  async function handleLogout() {
    setLoading(true);
    setError(undefined);
    try {
      await logout();
    } catch (e) {
      // Igual limpiamos el cliente aunque el backend falle.
      setError(mapApiError(e));
    } finally {
      clear();
      navigate('/login', { replace: true });
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center gap-2">
      {error && (
        <span role="alert" className="text-xs text-destructive">
          {error}
        </span>
      )}
      <Button variant="outline" size="sm" onClick={handleLogout} disabled={loading}>
        {loading ? 'Saliendo…' : 'Cerrar sesión'}
      </Button>
    </div>
  );
}